import React from "react";
import styles from "../../../assets/stylesheets/blog/FarmmodeBlogDetail.module.css";
import MainImg from "../../../assets/img/blog/easter/MainEaster.webp"; 

import Downeys from "../../../assets/img/blog/easter/Downeys.webp"; 
import ErinHill from "../../../assets/img/blog/easter/ErinHill.webp"; 
import Kustermans from "../../../assets/img/blog/easter/Kustermans.webp"; 
import Pingles from "../../../assets/img/blog/easter/Pingles.webp"; 
import Valleyview from "../../../assets/img/blog/easter/Valleyview.webp"; 

const EASTER_FARMS = [
  {
    farms: [
      {
        name: "1. Downey's Farm Market: Easterfest 2025",
        img: Downeys,
        subTitle: "A family favorite with a wonderful array of Easter activities.",
        description: "A family favorite, Downey‘s Farm is once again presenting its highly popular Easter Festival 2025! With a wonderful array of family-oriented Easter activities, this festival is perfect for children and adults alike.",
        location: "13682 Heart Lake Rd, Caledon, ON L7C 2J5",
        website: "Downey's Farm Market",
        webUrl: "https://downeysfarm.com/",
        details: [
          { label: "Dates", value: "Saturday, April 12 & Sunday, April 13, 2025 | 9:30 AM - 5:00 PM | Friday, April 18 - Sunday, April 20, 2025 | 9:30 AM - 5:00 PM" },
          { label: "Activities", value: "Easter Egg Hunt 2025 (collect eggs and trade them in for a treat!) | Easter Egg Seek & Find | Easter Story Wagon Ride | Meet the Easter Bunny & His Helpers | Farm Animal Encounters | Magic & Puppet Shows | Bunny Ears Coloring Station" },
          { label: "Important Notes", value: "Ticket information will be available starting March 24, 2025. | Dress according to the weather as this is an outdoor event. | Boots are strongly suggested as it is muddy. | Bring your own Easter basket or purchase one here. | No pets, please." },
          { label: "Book Here", value: "https://downeysfarm.com/" }       
        ]
      },
      {
        name: "2. Kustermans Adventure Farm - Easter Festival 2025",
        img: Kustermans,
        subTitle: "Exciting attractions, Easter activities, and outdoor adventures.",
        description: "Kustermans Adventure Farm invites families to a weekend of Easter celebration with exciting attractions, Easter activities, and outdoor adventures for kids of all ages!",
        location: "23188 Springwell Rd, Mount Brydges, ON N0L 1W0",
        website: "Kustermans Adventure Farm",
        webUrl: "https://www.kustermans.ca/",
        details: [
          { label: "Dates", value: "Saturday, April 12 - Sunday, April 13, 2025 | 10:00 AM - 6:00 PM | Friday, April 18 - Sunday, April 20, 2025 | 10:00 AM - 6:00 PM" },
          { label: "Activities", value: "Farm Animal Interactions | Play Tractor & Speedway | Horse Riders & Wagon Rides | Giant Jump Pad & Bouncy Town | Easter Egg Hunt (ride the wagon to the hunt!) | Meet the Easter Bunny" },
          { label: "Admission", value: "Online: $21 per person | At the Gate: $25 per person (taxes not included) | Free for kids under 24 months" },
          { label: "Important Notes", value: "Bring your own Easter basket for the hunt. | For health and safety reasons, pets are not allowed on the farm." },
          { label: "Book Here", value: "https://kustermans.ca/tickets/" }
        ]
      },
      {
        name: "3. Pingle's Farm Market - Sp-Egg-Tacular Easter Celebration",
        img: Pingles,
        subTitle: "Welcome spring with a family Easter celebration.",
        description: "Pingle’s Farm is getting ready to welcome spring with a family Easter celebration, complete with entertainment, spring farm activities, and adorable farm animals.",
        location: "1805 Taunton Rd, Hampton, ON L0B 1J0",
        website: "Pingle's Farm Market",
        webUrl: "https://pinglesfarmmarket.com/",
        details: [
          { label: "Dates", value: "Saturday, April 12 - Sunday, April 13, 2025 | 9:30 AM - 5:00 PM (Last entry at 4:00 PM) | Friday, April 18 - Sunday, April 20, 2025 | 9:30 AM - 5:00 PM" },
          { label: "Activities", value: "Easter Egg Hunt | Meet the Easter Bunny | Live Music (Socks & Sandals Band) | Wagon Rides | Visit the NEW Animal Barn (goats, chickens, sheep, donkeys & llamas!) | Playtime in Pingle's Playland" },
          { label: "Live Music Schedule", value: "April 12-13, April 18-20 | Showtimes: 10:30 AM, 12:00 PM, 1:30 PM, 3:00 PM" },
          { label: "Admission", value: "Pre-sale tickets: $16 + HST & Fees | At-the-door tickets: $4 increase (subject to availability) | Free for children under 2 years" },
          { label: "Important Notes", value: "The market & bakery are open 7 days a week year round, no ticket required to shop." },
          { label: "Book Here", value: "https://pinglesfarmmarket.com/events/" }
        ]
      },
      {
        name: "4. Valleyview Little Animal Farm",
        img: Valleyview,
        subTitle: "A hidden gem for kid-friendly Easter activities.",
        description: "A hidden gem for kid-friendly Easter activities, Valleyview Little Animal Farm offers a warm Easter egg hunt experience in a casual farm setting.",
        location: "4750 Fallowfield Rd, Nepean, ON K2J 4S4",
        website: "Valleyview Little Animal Farm",
        webUrl: "https://www.valleyviewlittleanimalfarm.com/",
        details: [
          { label: "Dates", value: "Friday, April 18, 2025 | 9:30 AM - 12:30 PM OR 1:00 PM - 4:00 PM" },
          { label: "Activities", value: "Farm-Themed Play Area | Meet & Greet with Little Farm Animals | Easter Egg Hunt | Scenic Country Walks | Train Ride on \"All Aboard!\" | Explore Bill's Old Farm Museum" },
          { label: "Admission", value: "$14 (tax included) per person (ages 2 - 99) | Major debit/credit cards accepted" },
          { label: "Important Notes", value: "Reservations are required for Easter Weekend. | Online reservations open March 15, 2025." },
          { label: "Book Here", value: "https://www.valleyviewlittleanimalfarm.com/" }
        ]
      },
      {
        name: "5. Erin Hill Acres - Spring Egg-Stravaganza",
        img: ErinHill,
        subTitle: "Join in a spring farm festival at Erin Hill Acres.",
        description: "Join in a spring farm festival at Erin Hill Acres with an Easter Egg Hunt, photo opportunities, and other family-friendly Easter activities.",
        location: "5837 3 Line, Erin, ON N0B 1Z0",
        website: "Erin Hill Acres Farm",
        webUrl: "https://erinhillacres.ca/",
        details: [
          { label: "Dates", value: "Friday, April 18 -19 | 8:30 AM – 1:00 PM, 1:00 PM - 5:00 PM | Sunday, April 20 | 10:00 - 2:00 PM" },
          { label: "Activities", value: "Easter Egg Hunt | Photo Opportunities with the Easter Bunny | Spring-themed activities | D.J. Music & MC by D.J Frances | Free face painting (subject to availability) | Tractor-drawn wagon rides" },
          { label: "Admission", value: "Online ticket information" },
          { label: "Important Notes", value: "Reservations are required. No tickets will be sold at the door. | Every visitor (adults & non-participating children) must pay admission. | Egg scrambles are very quick! Plan to arrive at least 45 minutes early. | Bring your own Easter basket for collecting eggs." },
          { label: "Book Here", value: "https://erinhillacres.ca/" }
        ]
      }
    ]
  }
];

export default function CelebrateEaster() {
  return (
    <div className={styles.page}>

      {/* Top meta like blogTO */}
      <div className={styles["top-meta"]}>
        {/* <span className={styles["category-name"]}>Celebrate Easter</span>
        <span className={styles["sep"]}>•</span>
        <span>FarmCiti News</span>
        <span className={styles["sep"]}>•</span>
        <span>Posted Mar 20, 2025</span> */}
      </div>

      {/* Main Title */}
      <h1 className={styles["title"]}>Celebrate Easter 2025 at Local Farms: Fun, Adventure, and Family-Friendly Activities</h1>

      {/* Hero Image */}
      <div className={styles["hero-wrap"]}>
        <img
          className={styles["hero"]}
          src={MainImg}
          alt="Easter Farm Fun"
        />
      </div>

      <div className={styles["lead-section"]}>
        <p><strong>Easter 2025 is coming up soon, and a trip to a local farm could be the perfect way to celebrate.</strong><br />
        Across the region, several farms are welcoming families for a delightful Easter experience, complete with Easter egg hunts, farm animal encounters, festive wagon rides, and more. Whether you’re looking for an exciting outdoor adventure or a cozy farm setting to enjoy the season, these five must-visit farms have something special planned for everyone!</p>
      </div>

      <div className={styles["jump-links"]}>
        {/* Simple jump link placeholder if needed */}
      </div>

      {EASTER_FARMS.map((region, idx) => (
        <div key={idx}>
          {region.region && (
            <>
            <h2 className={styles["region-title"]}>{region.region}</h2>
            <hr className={styles["region-divider"]} />
            </>
          )}
          
          {region.farms.map((farm, fIdx) => (
            <div key={fIdx} className={styles["farm-section"]}>
              <h3 className={styles["farm-name"]}>{farm.name}</h3>
              <hr className={styles["region-divider"]} />
              
              {farm.img && <img src={farm.img} alt={farm.name} className={styles["farm-image"]} />}
              
              <div className={styles["farm-description"]}>
                <p><strong>{farm.subTitle}</strong></p>
                <p>{farm.description}</p>
              </div>

              <div className={styles["event-details-title"]}>Event Details:</div>
              <ul className={styles["details-list"]}>
                <li className={styles["details-item"]}>
                  <span className={styles["details-label"]}>Location:</span> {farm.location}
                </li>
                <li className={styles["details-item"]}>
                  <span className={styles["details-label"]}>Website:</span><br />
                  <a href={farm.webUrl} className={styles["website-link"]} target="_blank" rel="noopener noreferrer">
                    {farm.website}
                  </a>
                </li>
                {farm.details && farm.details.map((detail, dIdx) => {
                  const isHighlight = ["Important Notes"].includes(detail.label); // Only Important Notes gets the highlight box
                  const isList = ["Activities", "Admission", "Live Music Schedule", "Dates"].includes(detail.label); // These get lists but no box
                  const isLink = detail.label === "Book Here";
                  
                  if (isLink) {
                     return (
                      <li key={dIdx} className={styles["details-item"]}>
                         <span className={styles["details-label"]}>{detail.label}:</span> <br/>
                         <a href={detail.value} className={styles["website-link"]} target="_blank" rel="noopener noreferrer">
                            Visit Booking Page
                         </a>
                      </li>
                     );
                  }

                  // Common logic for splitting content into items
                  let contentItems = [];
                  if (detail.value.includes('|')) {
                    contentItems = detail.value.split('|').map(s => s.trim());
                  } else if (detail.label === "Activities" && detail.value.includes(',')) {
                      contentItems = detail.value.split(',').map(s => s.trim());
                  } else {
                    contentItems = [detail.value];
                  }

                  if (isHighlight) {
                    return (
                      <li key={dIdx} className={styles["highlight-detail"]}>
                        <span className={styles["highlight-label"]}>{detail.label}</span>
                        <div className={styles["highlight-content"]}>
                          <ul className={styles["highlight-list"]}>
                            {contentItems.map((item, i) => (
                              <li key={i}>{item}</li>
                            ))}
                          </ul>
                        </div>
                      </li>
                    );
                  }

                  if (isList) {
                    return (
                      <li key={dIdx} className={styles["details-item"]}>
                        <span className={styles["details-label"]}>{detail.label}:</span>
                        <ul className={styles["highlight-list"]} style={{ marginTop: '8px', marginBottom: '0' }}>
                          {contentItems.map((item, i) => (
                            <li key={i}>{item}</li>
                          ))}
                        </ul>
                      </li>
                    );
                  }

                  return (
                    <li key={dIdx} className={styles["details-item"]}>
                      <span className={styles["details-label"]}>{detail.label}:</span> {detail.value}
                    </li>
                  );
                })}
              </ul>
              <hr className={styles["farm-divider"]} />
            </div>
          ))}
        </div>
      ))}

      <div className={styles["lead-section"]}>
        <h2 className={styles["title"]} style={{ fontSize: '2rem', marginTop: '3rem' }}>Hop into Easter Fun!</h2>
        <p>These Easter farm events in your region are gearing up to make lifelong memories in 2025. Gather your family and friends and celebrate the holiday in an active and festive way! From interactive Easter egg hunts to visits with farm animals, there is no better way to usher in the spring season.</p>
        <p>Which farm would you most like to visit this Easter? Let us know in the comments!</p>
      </div>
    </div>
  );
}
